import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — restores scroll position when navigating between pages.
 * Default: scroll to top on route change.
 * If the URL has a hash (e.g. /about#faculty), smoothly scroll to the element with that id.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Reset to top synchronously before the browser paints to avoid flicker
  useLayoutEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  // Handle hash targets after the new page has mounted
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    let tries = 0;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (tries++ < 10) setTimeout(tryScroll, 60);
    };
    tryScroll();
  }, [pathname, hash]);

  return null;
}
